export let ConnectionStatusTypes;
(function (ConnectionStatusTypes) {
  ConnectionStatusTypes["UNINITIALIZED"] = "UNINITIALIZED";
  ConnectionStatusTypes["STARTED"] = "STARTED";
  ConnectionStatusTypes["SUCCEEDED"] = "SUCCEEDED";
  ConnectionStatusTypes["FAILED"] = "FAILED";
  ConnectionStatusTypes["UNSUPPORTED"] = "UNSUPPORTED";
  ConnectionStatusTypes["DISCONNECTING"] = "DISCONNECTING";
  ConnectionStatusTypes["DEPRECATED"] = "DEPRECATED";
})(ConnectionStatusTypes || (ConnectionStatusTypes = {}));